<template>
	<div full-height>

		<div id="non-printable">

			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">Preview</v-toolbar-title>

			    <v-spacer></v-spacer>

				<!-- <v-btn color="success" @click="fn_toDevices">devices</v-btn> -->

				<div v-if="$root.appVersion >= 230 && invoiceLoaded && templateNo != 101 && data && $root.fn_getFormNameByListId(data.transactionDetails.transactionListId) == 'Sale'" @click="$refs['ref_previewTemplate'].fn_compressBusinessLogo" font-medium font12 style="padding-top: 8px;margin-right: 8px;" center-align primary-color>
					<div style="margin-bottom: -4px;"><v-icon font20>print</v-icon></div>
					<div>Thermal</div>
				</div>

				<div v-if="$root.appVersion >= 230 && showThermalPrintBtn && ($root.fn_getFormNameByListId(data.transactionListId) == 'Receipt' || $root.fn_getFormNameByListId(data.transactionListId) == 'Payment')" @click="$refs['ref_previewTemplate'].fn_compressBusinessLogo" font-medium font12 style="padding-top: 8px;margin-right: 8px;" center-align primary-color>
					<div style="margin-bottom: -4px;"><v-icon font20>print</v-icon></div>
					<div>Thermal</div>
				</div>

				<!-- <v-btn color="success" v-if="showThermalPrintBtn" @click="$refs['ref_previewTemplate'].fn_compressBusinessLogo">Thermal</v-btn> -->
				<!-- <v-btn small flat @click="fn_toDevices" v-if="invoiceLoaded"><v-icon>print</v-icon> Thermal</v-btn> -->

			    <v-btn icon flat @click="fn_templateSettings" v-if="invoiceLoaded && this.$route.query.template_no != 301 && this.$route.query.template_no != 302"><v-icon>settings</v-icon></v-btn>

			    <v-menu v-if="data && data.transactionDetails && data.transactionDetails.transactionListId == 10003 && invoiceLoaded">
			      	<v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
			      	<v-list nopadding>
			        	<v-list-tile v-for="(item, index) in invoiceTypes" :key="index" @click="fn_invoiceFor(item)">
			          		<v-list-tile-title>{{item}}</v-list-tile-title>
			          		<v-list-tile-action style="justify-content: end;">
				        		<v-icon color="primary">{{item == invoiceFor ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon>
				        	</v-list-tile-action>
			        	</v-list-tile>
			      	</v-list>
			    </v-menu>

				<!-- <v-menu v-if="data && data.transactionDetails && invoiceLoaded">
			      	<v-btn slot="activator" icon>{{ fontValue == 0 ? 'A-' : fontValue == 2 ? 'A+' : 'A'}}</v-btn>
			      	<v-list nopadding>
			        	<v-list-tile @click="fn_saveFontSize(1)">
			          		<v-list-tile-title>Normal</v-list-tile-title>
			        	</v-list-tile>

						<v-list-tile @click="fn_saveFontSize(0)">
			          		<v-list-tile-title>Small</v-list-tile-title>
			        	</v-list-tile>

						<v-list-tile @click="fn_saveFontSize(2)">
			          		<v-list-tile-title>Large</v-list-tile-title>
			        	</v-list-tile>
			      	</v-list>
			    </v-menu> -->

				<!-- <v-btn flat color="primary" @click="fn_generateImage">Test</v-btn> -->

			</v-toolbar>

			<!-- <div full-height class="hasToolbar grey-back" style="display:flex;justify-content:center"> -->
			<div full-height class="hasToolbar hasBigFooter" :class="{'hasBigFooterWithExtentionPlus':showInvoiceSettingAlert}">

				<!-- <div style="overflow-x:scroll"> -->
				<!-- <div white-background style="transform-origin: 50% 24px 0px;flex:1;" :class="[hasItems ? data.transactionDetails.roundedAmount > 9999999 ? 'transform-preview-with-items-large' : 'transform-preview-with-items' : 'transform-preview']"> -->
				<!-- <div white-background style="transform-origin: 50% 24px 0px;flex:1;" :class="[headersColumnCount >= 10 ? 'transform-preview-with-items-xlarge' : fn_getTransformClass()]"> -->
				<v-progress-linear height="4" nomargin indeterminate color="primary" v-if="!invoiceLoaded && templateNo!=101"></v-progress-linear>

				<div white-background id="preview_wrapper" style="border:1px #ddd dashed" :style="[$root.platform === 'ios' ? {'transform': 'scale('+zoomPercent+')', 'transform-origin': 'top center'} : {'zoom': zoomPercent}]" :class="{'visibility-hidden':!invoiceLoaded && templateNo!=101, 'grey-back':templateNo==7, 'ma-2':invoiceLoaded}">
					<!-- <template v-show="invoiceLoaded"> -->
						<!-- <component :is="previewTemplate" ref="ref_previewTemplate" :data="data" :preview="true" :isEditable="false" :themeColor="themeColor" :invoiceFor="invoiceFor" :headersLength="fn_headersLength" v-if="previewTemplate && data!=null"></component> -->
                        <component :is="previewTemplate" ref="ref_previewTemplate" :data="data" :preview="true" :isEditable="false" :themeColor="themeColor" :invoiceFor="invoiceFor" :headersLength="fn_headersLength" v-if="previewTemplate && data!=null"></component>
					<!-- </template> -->
				</div>


				<div white-background id="invoice_setting_alert" v-if="invoiceLoaded && showInvoiceSettingAlert && templateNo!=101" font14 style="position: fixed;bottom: 60px;width:100%;">
					<div class="pt-2 pb-2 pl-3 pr-3" style="display: flex;background-color: rgba(66, 165, 245, 0.15) !important;">
					<!-- <span>Want to customise this Invoice Print?</span> -->
					<span>Want to customise this {{ data.transactionDetails.invoiceTitle }} Print? <br>Tip: Click on <v-icon color="primary" font20>settings</v-icon> on the toolbar and customise it</span>
					<!-- <span>Tap on <v-icon color="primary" font20>settings</v-icon> in the header and customise the invoice template as per your needs.</span> -->
					<v-spacer></v-spacer>
					<v-icon font20 @click="fn_closeAlert">close</v-icon>
				</div>
				</div>
				<v-footer class="invoice-footer-actions" v-if="invoiceLoaded">

					<v-layout white-background grid wrap text-xs-center>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_initPrintTemplate('sharewhatsapp')">
							<div right-border>
								<div style="height:26px"><img src="../../assets/icon_whatsapp.svg" alt="whatapp_icon"></img></div>
						    	<div font11 class="font-weight-bold">Send</div>
							</div>	
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_initPrintTemplate('share')">
						    <div right-border>
						    	<div><v-icon>share</v-icon></div>
						    	<div font11 class="font-weight-bold">Share</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_initPrintTemplate('print')">
						    <div right-border>
						    	<div><v-icon>print</v-icon></div>
						    	<div font11 class="font-weight-bold">Print</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_initPrintTemplate">
						    <div right-border>
						    	<div><v-icon>vertical_align_bottom</v-icon></div>
						    	<div font11 class="font-weight-bold">Download</div>
						    </div>
						</v-flex>

					</v-layout>

					<div v-ripple class="pb-2 pt-2" center-align style="width:20%" white-background @click="fn_newInvoice">
		              	<v-icon>add_circle_outline</v-icon>   
		              	<div font11 class="font-weight-bold">New</div>
		            </div>
				</v-footer>
			</div>
		</div>
		

		<div id="printable" full-width>
            <component :is="printTemplate" ref="ref_printTemplate" :data="data" :themeColor="themeColor" :invoiceFor="invoiceFor" v-if="printTemplate && data!=null"></component>
		</div>

		<v-snackbar v-model="snackbar">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>

		<dialog-share-transaction ref="ref_dialogShareTransaction" :actionMethod="fn_shareTransaction"></dialog-share-transaction>

		<!-- <v-btn color="success" @click="fn_enableBluetooth">text</v-btn> -->

		<!-- <v-btn color="success" @click="fn_toDevices">devices</v-btn> -->

		<!-- <v-btn color="success" @click="fn_openThermalView">view</v-btn> -->

		<!-- <v-btn color="success" @click="fn_scandevice">scan</v-btn> -->

		<!-- <v-btn color="success" @click="fn_printReceipt">Print</v-btn> -->

		<!-- <v-btn color="success" @click="fn_callBackgroundView">call view</v-btn> -->

		<!-- <div v-for="(item, index) in pairedList.pairedDevices" @click="fn_connectDevice(index)" v-if="pairedList && pairedList.pairedDevices && pairedList.pairedDevices.length">
			{{ item.name }}
		</div> -->
		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->
	</div>	
</template>

<script>
const menuItem = require('../../config.js').configs.menuItem;
const transactionForms = require('../../config.js').configs.transactionForms;
import dialogShareTransaction from '../dialogs/dialog_share_transaction.vue';

import domtoimage from 'dom-to-image';
// import dialogPermission from '../dialogs/dialog_permission';

	export default{
		components:{
	      'dialog-share-transaction': dialogShareTransaction,
	    },
		data(){
			return{
				data:null,
				billingAddress:null,
				partyPhoneBilling:null,
				partyPhoneShipping:null,
				shippingAddress:null,
				otherFields:[],
				headers:[],
				items:[],
				summary:{"totalTax":0},
				addOnsTotal:[],
				gstAddOnsTotal:[],
				netTotal:0,
				isHsn:false,
				isMrp:false,
				header:{data:null, fieldId:null},
				terms:{data:null, field:null},
                printNote:{data:null, field:null},
				bankDetails:{data:null, field:null},
				signatory:{data:null, field:null},
				subtitle:{data:null, field:null},
				isRef:false,
				colors:["#4b77be", "rgba(211,211,211,0.4)", "rgba(128,128,128,0.4)", "rgba(0,128,128,0.4)", "rgba(173,216,230,0.4)", "rgba(144,238,144,0.4)", "rgba(135,206,250,0.4)", "((255,182,193,0.4))"],
				themeColor:null,
				previewTemplate:null,
				printTemplate:null,
				templateNo:1,
				templates:[1, 2, 3, 4, 5],
				snackbar:false,
				invoiceTypes:["Standard", "Original For Recipient", "Duplicate For Transporter", "Duplicate For Supplier", "Triplicate For Supplier"],
				invoiceFor:"Standard",
				hasItems:false,
				headersColumnCount:0,
				zoomPercent:"100%",
				invoiceLoaded:false,
				pairedList:{pairedDevices:null},
				ThermalPrintSettings:null,
				showThermalPrintBtn:false
				// fontValue:1
			}		
		},
		methods:{

			// fn_saveFontSize: function(value){
			// 	this.fontValue = value;
			// 	let dataObj = {LocalKey:'invoiceFontClassValue',LocalValue:this.fontValue}
			// 	this.$root.fn_saveLocalItem(dataObj);
			// 	this.invoiceLoaded = false;
			// 	this.data = null;
			// 	this.previewTemplate = null;
			// 	this.printTemplate = null;
			// 	this.zoomPercent = "100%";
			// 	this.fn_bindInvoiceTemplate();
			// },

			fn_closeAlert: function(){
				document.getElementById('invoice_setting_alert').remove();
				localStorage.setItem('invoice_setting_alert', 1);
			},

			fn_invoiceFor: function(invoiceForText){
				this.invoiceFor = invoiceForText;

                // setTimeout(() => {
                //     let borderElements = document.getElementsByClassName('theme-border-color');
                //     for(let i=0;i<borderElements.length;i++){
                //         borderElements[i].style.borderColor = this.data.templateSettings.themeColor;
                //     }
                // }, 500);
			},

			fn_getTransformClass: function(){
				if(this.hasItems){
					// if(this.$refs['ref_previewTemplate'] && this.$refs['ref_previewTemplate'].headers.length >= 10){
					// 	return 'transform-preview-with-items-xlarge';
					// }
					if(this.data.transactionDetails.roundedAmount > 9999999){
						return 'transform-preview-with-items-large';
					}
					else{
						return 'transform-preview';
					}
				}
				else{
					return 'transform-preview'
				}
			},

			fn_headersLength: function(length){
				this.headersColumnCount = length;
			},

			fn_calculateZoomPercent: function(headerWidth, templateNo){
				// alert(tableWidth);
				// let bodyTableElement = document.getElementById("body_template_"+this.templateNo);
				// let percentage = ((window.outerWidth - 32) / bodyTableElement.offsetWidth) * 100;
				// let headerTableElement = document.getElementById("header_template_"+this.templateNo);
				// let elementWidth = Number(headerTableElement.style.minWidth.replace("px", ''));
				if(!headerWidth && templateNo == 7){
					this.zoomPercent = "75%";
					this.invoiceLoaded = true;
					return;
				}

				let elementWidth = Number(headerWidth.replace("px", ''));
				let percentage = ((window.outerWidth - 32) / elementWidth) * 100;
				console.log(percentage);
				this.zoomPercent = percentage + '%';

				let self = this;
				setTimeout(function(){
					self.invoiceLoaded = true;
                    // self.fn_changeColor(self.data.templateSettings.themeColor);  
				},300);
			},

			fn_newInvoice: function () {

	            localStorage.setItem("SetDataDrive", 1);
	            if(this.$route.query.type){
	            	this.$router.replace({path:'/transactions/'+this.$route.query.type+'/'+this.$route.query.title.toLowerCase().replace(/ /g,'')+'/items/new', query:{tagId:this.guidWeb()}});	
	            }
	            else{
	            	this.$router.replace({path:'/transactions/'+this.$route.query.title.toLowerCase().replace(/ /g,'')+'/items/new', query:{tagId:this.guidWeb()}});
	            }
	            
	        },

			// fn_changeColor: function(color){				
			// 	this.printTemplate = null;
			// 	this.themeColor = color;
			// },

			fn_templateSettings: function(){
	            let toolbarTitle = this.$route.query.title.toLowerCase().replace(/ /g,'');
	            this.$router.push({path:"/invoice/preview/settings", query:{"title": this.$route.query.title, "listId":this.$route.query.listId, "tId":this.$route.query.tId, "template_no":this.$route.query.template_no, "printtype":this.$route.query.printtype, "invoiceFor":this.invoiceFor}});
			},

			fn_bindInvoiceTemplate: function(){
				console.log(this.previewTemplate);
				if(this.$route.query.template_no == 301 || this.$route.query.template_no == 302){
					this.fn_getPrintData();
				}
				else{
					this.fn_getInvoiceData();
				}
			},

			fn_getInvoiceData: function(name){
	            var self = this;
	            let fName = null;
	            if(this.$route.query.printtype){
	            	fName = this.$route.query.printtype == 'ab' ? "AccountBookPrintData" : "StockJournalPrintData";
	            }
	            else{
	            	fName = "InvoiceData"
	            }
	            
	            this.getData(fName, this.$route.query.tId, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.data = JSON.parse(response);
	                        self.templateNo = self.data.templateSettings.invoiceTemplate;
	                        self.themeColor = self.data.templateSettings.themeColor;
                            

							if(self.$root.appVersion >= 117){
								self.previewTemplate = require('./invoices/template'+self.templateNo).default;
	                        	// self.printTemplate = require('./invoices/template'+self.templateNo).default;
								if(self.$root.TransactionSettings.fullPagePrint && self.templateNo != 101 && self.templateNo != 201){
									self.printTemplate = require('./invoices/template1001').default;
								}
								else{
									self.printTemplate = require('./invoices/template'+self.templateNo).default;
								}
							}
							else{
								self.previewTemplate = require('./invoices_old/template'+self.templateNo).default;
	                        	self.printTemplate = require('./invoices_old/template'+self.templateNo).default;
							}

	                        if(self.templateNo == 101){
	                        	self.invoiceLoaded = true;

	                        	// sorting as per amount types
								self.data.transactionLedgers.sort(function(a, b){
									return b.amountType - a.amountType;
								});
	                        	// sorting transaction ledgers as per order number
								self.data.transactionLedgers.sort(function(a, b){
									return a.orderNumber - b.orderNumber;
								});
	                        }
							else{
								if(self.data.transactionDetails.transactionListId == 10005){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.estimatePrintTitle ? self.$root.TransactionSettings.estimatePrintTitle : 'Estimate';
								}
								else if(self.data.transactionDetails.transactionListId == 10004){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.saleReturnPrintTitle ? self.$root.TransactionSettings.saleReturnPrintTitle : 'Sale Return';
								}
								else if(self.data.transactionDetails.transactionListId == 20004){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.purchaseReturnPrintTitle ? self.$root.TransactionSettings.purchaseReturnPrintTitle : 'Purchase Return';
								}
								else if(self.data.transactionDetails.transactionListId == 10003 && self.$root.CurrentBusiness.GSTRegistrationStatus != 1){
									if(self.$root.TransactionSettings.invoicePrintTitle && self.$root.TransactionSettings.invoicePrintTitle != 'Default'){
										self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.invoicePrintTitle;
									}
								}
							}
	                        

	                        if(self.data.transactionDetails && self.data.transactionDetails.transactionItems && self.data.transactionDetails.transactionItems.length){
	                        	self.hasItems = true;
	                            // self.fn_removeZeroTaxAddons();
	                        }
	                        else{
	                        	self.hasItems = false;
	                        }

	                        setTimeout(function(){
	                        	self.$refs['ref_previewTemplate'].fn_init(self.templateNo);
								self.showThermalPrintBtn = true;
	                        },300);

	                        setTimeout(function(){
	                        	self.$refs['ref_printTemplate'].fn_init(self.templateNo, self.fn_calculateZoomPercent);
	                        },1000);

							if(self.data.transactionDetails && self.data.transactionDetails.additionalData){
								self.data.transactionDetails.additionalData = JSON.parse(self.data.transactionDetails.additionalData);
							}

							// self.$root.fn_getLocalItem('invoiceFontClassValue', response=>{
							// 	let data = JSON.parse(response);
							// 	if(data && data.LocalValue){
							// 		self.fontValue = data.LocalValue;
							// 	}
							// });
	                    }, 
	                    onError: function(error){
	                        console.log(error);           
	                    }
	                }
	            );
	        },

			fn_getPrintData: function(){
	            var self = this;
	            let fName = this.$route.query.template_no == 301 ? "StockTransferInvoiceData" : "BOMInvoiceData";;
	            
	            this.getData(fName, this.$route.query.tId, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.data = JSON.parse(response);
	                        self.templateNo = self.$route.query.template_no;

							self.previewTemplate = require('./invoices/template'+self.templateNo).default;
							self.printTemplate = require('./invoices/template'+self.templateNo).default;

							self.invoiceLoaded = true;
	                        
	                        setTimeout(function(){
	                        	self.$refs['ref_previewTemplate'].fn_init(self.templateNo);
	                        },300);

	                        setTimeout(function(){
	                        	self.$refs['ref_printTemplate'].fn_init(self.templateNo, self.fn_calculateZoomPercent);
	                        },1000);
	                    }, 
	                    onError: function(error){
	                        console.log(error);           
	                    }
	                }
	            );
	        },

            // fn_changeColor: function(color){
            //     let elements = document.getElementsByClassName('theme-color');
            //     for(let i=0;i<elements.length;i++){
            //         elements[i].style.backgroundColor = color;
            //     }

            //     let borderElements = document.getElementsByClassName('theme-border-color');
            //     for(let i=0;i<borderElements.length;i++){
            //         borderElements[i].style.borderColor = color;
            //     }
			// },

	        fn_removeZeroTaxAddons: function(){
	        	for(let i=0; i<this.data.transactionDetails.transactionItems.length; i++){
	        		let item = this.data.transactionDetails.transactionItems[i];
	        		item.cols.addOns = item.cols.addOns.filter(addOnsItem => {
	        			return addOnsItem.percentage != 0;
	        		});
	        	}
	        },

			fn_openDialogShareTransaction: function(){
				this.$refs['ref_dialogShareTransaction'].openDialogWeb();
			},

			fn_shareTransaction: function(type){
				this.$refs['ref_dialogShareTransaction'].closeDialogWeb();
				if(type=='pdf'){
					this.fn_initPrintTemplate('share')
				}
				else if(type == 'image'){
					this.fn_htmlToImage();
				}
			},

			fn_htmlToImage: function(){
				this.showLoading("Please wait...");
		        var element = document.getElementById('printable');
				// node.style.display = "block";
				// node.style.minWidth = '600px';
				// node.style.padding = '16px';

				var z = document.createElement('div');
				z.innerHTML = element.innerHTML;
				z.id = "printcopy"
				z.style.display = "block";
				z.style.minWidth = '600px';
				z.style.padding = '16px';
				z.style.zIndex = '-1';
				z.style.position = 'absolute';
				z.style.top = '0px';
				// document.body.appendChild(z);
				document.getElementById('non-printable').appendChild(z);
				document.body.overflowX = "hidden";

				// setTimeout(() => {
				// 	z.remove();
				// });


                let self = this;
                domtoimage.toPng(z).then(function (dataUrl) {
					z ? z.remove() : '';
					self.hideLoading();
					document.body.overflowX = "inherit";
                    self.fn_shareQrCode(dataUrl);
                })
                .catch(function (error) {
                    console.error('oops, something went wrong!', error);
					z ? z.remove() : '';
					document.body.overflowX = "inherit";
                });
		    },

			fn_shareQrCode: function(dataUrl){
            	let shareObj = {};
	            shareObj.type = "image"
	            shareObj.shareType = "share"
	            shareObj.primaryMobileNumber = null;
	            shareObj.email = null;
	            shareObj.subject = null;
	            shareObj.textMessage = this.$tShare('share.qrCodeMessage');
	            // shareObj.base64String = this.dataUrl.substring(this.dataUrl.indexOf(',') + 1);
	            shareObj.base64String = dataUrl.substring(dataUrl.indexOf(',') + 1);
	            this.$root.fn_share(shareObj);
            },

			fn_initPrintTemplate: function(type){
				let self = this;
				setTimeout(function(){
					// if(self.templateNo != 101 && self.templateNo != 301 && self.templateNo != 302){
					// 	self.$refs['ref_printTemplate'].fn_descriptionColspanValue2();
					// }

					if(self.$root.TransactionSettings.fullPagePrint && document.querySelector('.page.receipt_template')){
						let fullPageElement = document.querySelector('.page.receipt_template');
						let heightInMM = fullPageElement.offsetHeight * 0.264583; // convert px to mm
						// document.querySelectorAll('.page.receipt_template .spacer-row')[0].style.height = (297 - heightInMM) + 'mm';
						document.querySelectorAll('.page.receipt_template .spacer-row')[1].style.height = (297 - heightInMM - 20) + 'mm';
					}
					
					if(type=='print'){
						setTimeout(() => {
							self.fn_printInvoice();
						}, 300);
					}
					else{
		                self.$root.fn_checkStoragePermission(function(){
		                    if(type=='sharewhatsapp'){
								self.fn_shareInvoice('sharewhatsapp');
							}
							else if(type=='share'){
								self.fn_shareInvoice('share');
							}
							else{
								self.fn_exportToPdf(null);
							}
		                })
					}
				},300);
			},

	        fn_printInvoice: function(){
	        	let transactionNumber = null;
				let transactionId = null;
				let transactionForm = null;
	            let downloadTime = null;
	            if(this.data.transactionDetails){
	            	transactionNumber = this.data.transactionDetails.transactionNumber ? this.data.transactionDetails.transactionNumber : '';
					transactionId = this.data.transactionDetails.transactionId ? this.data.transactionDetails.transactionId : '';
					transactionForm = this.data.transactionDetails.transactionTypeFormName ? this.data.transactionDetails.transactionTypeFormName : '';
	            	downloadTime = this.data.transactionDetails.transactionDate ? new Date(this.data.transactionDetails.transactionDate) : new Date();
	            }
	            else{
	            	transactionNumber = this.data.transactionNumber ? this.data.transactionNumber : '';
					transactionId = this.data.transactionId ? this.data.transactionId : '';
					transactionForm = this.data.transactionDetails ? this.data.transactionTypeFormName : '';
	            	downloadTime = this.data.transactionDate ? new Date(this.data.transactionDate) : new Date();
	            }

	            let title = null;
	            if(this.data.transactionDetails){
	            	if(this.data.transactionDetails.transactionListId==10003){
	            		title = "Invoice";
	            	}
	            	else{
	            		title = this.fn_getTransactionTitle(this.data.transactionDetails.transactionListId);	
	            	}
	            }
	            else{
	            	title = this.data.invoiceTitle;
	            }

				let old = document.getElementById('dynamic-page-size');
    			if (old) old.remove();

				// setting up page size dynamically
				if(this.$root.TransactionSettings.fullPagePrint){
					this.$root.fn_settingUpPrintPageSize();
				}

	            let fileName = title.replace(/ /g,'') + '-' + transactionNumber.replace(/\//g,'') + '_' + this.$root.fn_getCurrentDateTimeString();
				let printPageSize = this.$root.TransactionSettings.printPageSize ? this.$root.TransactionSettings.printPageSize : 'A4';
	            let pageOrientation = this.$root.TransactionSettings.invoiceOrientation && !this.$root.TransactionSettings.fullPagePrint ? 'true' : 'false';
				// AndroidRoutingTest.print(fileName, printPageSize, pageOrientation);
				
				this.androidPrint(fileName, printPageSize, pageOrientation);

				let postObj = {
					// "eventName": 'print_'+title,
					"eventName": 'print_transaction',
					"eventData":[
						{"eventKey":"BusinessId","eventValue":this.$root.CurrentBusiness.BusinessID},
						{"eventKey":"TransactionId","eventValue":transactionId},
						{"eventKey":"TransactionNumber","eventValue":transactionNumber},
						{"eventKey":"TransactionForm","eventValue":transactionForm},
					]
					// "eventData":[
					// 	{"eventKey":"print_details","eventValue":title+'_#'+transactionNumber + ' from ' + this.$root.CurrentBusiness.BusinessName}
					// ]
				}
				this.$root.fn_postMetrics(postObj);
	        },

	        fn_shareInvoice: function(type){

				let shareObj = {};

		  		let title = null;
				let transactionNumber = null;
	            if(this.data.transactionDetails){
					transactionNumber = this.data.transactionDetails.transactionNumber ? this.data.transactionDetails.transactionNumber : '';
	            	if(this.data.transactionDetails.transactionListId==10003){
	            		title = "Invoice";
	            	}
					else if(this.data.transactionDetails.transactionListId==10001){
	            		title = "Sale Order";
	            	}
	            	else{
	            		title = this.fn_getTransactionTitle(this.data.transactionDetails.transactionListId);	
	            	}
	            }
	            else{
	            	title = this.data.invoiceTitle;
					transactionNumber = this.data.transactionNumber ? this.data.transactionNumber : '';
	            }

				// shareObj.subject = title + " Details";
				shareObj.subject = title + " #" + transactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
				shareObj.type = 'pdf';
				shareObj.primaryMobileNumber = null;
				shareObj.email = null;
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
				shareObj.transactionNumber = transactionNumber;

				let partyName = '';
				let transactionDate = null;
				let roundedAmount = null;
				if(this.data.transactionDetails){
					shareObj.primaryMobileNumber = this.data.transactionDetails.partyDetails && this.data.transactionDetails.partyDetails.primaryMobileNumber && type == 'sharewhatsapp' ? this.data.transactionDetails.partyDetails.primaryMobileNumber : null;
					shareObj.email = this.data.transactionDetails.partyDetails && this.data.transactionDetails.partyDetails.email ? [this.data.transactionDetails.partyDetails.email] : null ;
					partyName = this.data.transactionDetails.partyDetails && this.data.transactionDetails.partyDetails.partyName;
					transactionDate = this.data.transactionDetails.transactionDate;
					roundedAmount = this.data.transactionDetails.roundedAmount;
				}
				else{
					shareObj.primaryMobileNumber = this.data.partyDetails && this.data.partyDetails.primaryMobileNumber && type == 'sharewhatsapp' ? this.data.partyDetails.primaryMobileNumber : null;
					shareObj.email = this.data.partyDetails && this.data.partyDetails.email ? [this.data.partyDetails.email] : null ;
					partyName = this.data.partyDetails && this.data.partyDetails.partyName;
					transactionDate = this.data.transactionDate;
					roundedAmount = this.data.roundedAmount ? this.data.roundedAmount : 0;
				}
				
				let party = partyName ? partyName + ',' : '';

        		// shareObj.textMessage = "Dear "+party+"\n\nBelow are your " + title + " details. Please find the attached pdf.\n\nTransaction Date: "+this.$moment(transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
				shareObj.textMessage = this.$tShare('share.invoiceMessage', {
					party: party,
					title: title,
					number: shareObj.transactionNumber,
					date: this.$moment(transactionDate).format('DD-MMM-YYYY'),
					amount: this.$root.fixed2Decimal(roundedAmount),
					businessName: this.$root.CurrentBusiness.BusinessName
				});

				this.fn_exportToPdf(shareObj);
			},

	        fn_exportToPdf: function(shareObj){
	            let self = this;
	            let transactionNumber = null;
				let transactionId = null;
				let transactionForm = null;
	            let downloadTime = new Date();
	            if(this.data.transactionDetails){
	            	transactionNumber = this.data.transactionDetails.transactionNumber ? this.data.transactionDetails.transactionNumber : '';
					transactionId = this.data.transactionDetails.transactionId ? this.data.transactionDetails.transactionId : '';
					transactionForm = this.data.transactionDetails.transactionTypeFormName ? this.data.transactionDetails.transactionTypeFormName : '';
	            }
	            else{
	            	transactionNumber = this.data.transactionNumber ? this.data.transactionNumber : '';
					transactionId = this.data.transactionId ? this.data.transactionId : '';
					transactionForm = this.data.transactionTypeFormName ? this.data.transactionTypeFormName : '';
	            }

	            let title = null;
	            if(this.data.transactionDetails){
	            	if(this.data.transactionDetails.transactionListId==10003){
	            		title = "Invoice";
	            	}
	            	else{
	            		title = this.fn_getTransactionTitle(this.data.transactionDetails.transactionListId);	
	            	}
	            }
	            else{
	            	title = this.data.invoiceTitle;
	            }
	            
	            let fileName = title.replace(/ /g,'') + '-' + transactionNumber.replace(/\//g,'') + '_' + this.$root.fn_getCurrentDateTimeString();
				let pageOrientation = this.$root.TransactionSettings.invoiceOrientation && !this.$root.TransactionSettings.fullPagePrint ? 'true' : 'false';
	            this.exportToPdf(fileName+'.pdf', pageOrientation,{

	              onSuccess: function(response){
	                    console.log(response);
	                    if(shareObj != undefined)
	                        self.$root.fn_share(shareObj);
	                    else{
	                        self.showToast(title + ' downloaded');
	                        self.snackbar = true;
							
							let postObj = {
								"eventName": 'download_transaction',
								"eventData":[
									{"eventKey":"BusinessId","eventValue":self.$root.CurrentBusiness.BusinessID},
									{"eventKey":"TransactionId","eventValue":transactionId},
									{"eventKey":"TransactionNumber","eventValue":transactionNumber},
									{"eventKey":"TransactionForm","eventValue":transactionForm},
								]
								// "eventName": 'download_'+title,
								// "eventData":[
								// 	{"eventKey":"download_details","eventValue":title+'_#'+transactionNumber + ' from ' + self.$root.CurrentBusiness.BusinessName}
								// ]
							}
							self.$root.fn_postMetrics(postObj);
	                    }
	              }, 
	              onError: function(error){
	                  console.log(error);
	                  self.showToast(title + ' download failed');
	              }
	            });
	        },

	        fn_getTransactionTitle: function(transactionListId){
	            for(let i=0; i<transactionForms.length; i++){
	                if(transactionForms[i].id == transactionListId){
	                    return transactionForms[i].title;
	                }
	            }
	        },

		    fn_getBottomMenu: function () {

				var bottomMenu = {"BottomMenu": [menuItem.reset, menuItem.share]};
				let tagId = 'preview'
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='reset'){
					this.fn_reset();
				}
				else if(menuAction=='share'){
					this.fn_shareInvoice('share');
				}
				else if(menuAction=='help'){
					this.$router.push("/settings");
				}
			},

			// fn_openPermissionDialog: function(permissionType){
		    //     this.$root.permissionType = permissionType;
		    //     this.$refs['ref_dialogPermission'].dialog_permission = true;
		    // },

		    // fn_closeDialog: function(){
		    //     this.$refs['ref_dialogPermission'].dialog_permission = false;
		    // },

		    fn_goBack: function(){
		    	this.$router.go(-1);
		    },
			
			// fn_enableBluetooth: function () {
			// 	let self = this;
			// 	this.getData('EnableBluetooth', null, 
			// 		{
			// 		onSuccess: function(response){
			// 			console.log(response);
			// 			self.fn_checkBluetoothPermission();
			// 		}, 
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },

			// fn_checkBluetoothPermission: function () {
			// 	let self = this;
			// 	this.getData('CheckBluetoothPermission', null, 
			// 		{
			// 		onSuccess: function(response){
			// 			self.fn_allPairedDeviceList();
			// 			console.log(response);
			// 		}, 
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },

			// fn_allPairedDeviceList: function () {
			// 	let self = this;
			// 	this.getData('AllPairedDeviceList', null, 
			// 		{
			// 		onSuccess: function(response){
			// 			console.log(response);
			// 			self.pairedList = JSON.parse(response);
			// 		}, 
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },

			// fn_scandevice: function () {
			// 	let self = this;
			// 	this.getData('ScanBluetooth', null, 
			// 		{
			// 		onSuccess: function(response){
			// 			console.log(response);
			// 		}, 
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },

			// fn_connectDevice: function (index) {
			// 	let dataObj = {"BTDeviceIndex":index};
			// 	this.postData('ConnectToBluetoothDevice', dataObj, 
			// 		{
			// 		onSuccess: function(response){
			// 			console.log(response);
			// 		}, 
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },

			// fn_openThermalView: function () {
			// 	let dataObj = {"printThermalUrl":"https://bizopsstaging-thermal-print.web.app"}
			// 	this.postData('LoadThermalPrintApp', dataObj, 
			// 		{
			// 		onSuccess: function(response){
			// 			console.log(response);
			// 		}, 
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },


		},
		mounted(){
			// window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.fn_bindInvoiceTemplate();
			// this.fn_openThermalView()
		},
		computed:{
			zoomOutPercent: function(){
				if(document.getElementById("body_template_"+this.templateNo)){
					let bodyTableElement = document.getElementById("body_template_"+this.templateNo);
					let percentage = ((window.innerWidth - 32) / bodyTableElement.offsetWidth) * 100;
					console.log(percentage);
					return percentage;
				}
				else{
					return "100%";
				}
				
			},
			showInvoiceSettingAlert: function(){
				if(localStorage.getItem('invoice_setting_alert')){
					return false;
				}
				else{
					return true;
				}
			}
		},
		// beforeRouteLeave(to, from, next){
	    //   	if(this.$refs['ref_dialogPermission'].dialog_permission){
	    //     	this.$refs['ref_dialogPermission'].closeDialogWeb();
	    //     	next(false);
	    //   	}
	    //   	else{
	    //     	next();
	    //   	}
	    // },
	}
</script>


// WEBPACK FOOTER //
// src/components/invoice_templates/invoice_preview.vue